import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Conclusion() {
  return (
    <section className="Conclusion-serve-easy p-100 case-about-sec">
      <Container>
        <Row className="align-items-center justify-content-center">
            
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="">
            <div class="content text-center mb-5">
              <h2>
              Conclusion
              </h2>
              <p>Our strategic approach to ServeEasy’s development resulted in a powerful, scalable POS solution. It delivers superior performance, security, and user experience, setting a new standard for cloud-based POS systems in the hospitality industry.</p>
            </div>
          </Col>
          <Col
                xs={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className=""
            >
                <div className="image text-center mb-4">
                <StaticImage
                    src="../../../images/case-studies/serve-easy/conclusion.webp"
                    alt="The Challenge"
                    className=""
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={1654}
                    height={731}
                />
                </div>
          </Col>
          <Col
                xs={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className=""
            >
                <div className="image text-center mb-4">
                <StaticImage
                    src="../../../images/case-studies/serve-easy/screens.webp"
                    alt="The Challenge"
                    className=""
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={1602}
                    height={1034}
                />
                </div>
          </Col>
          
        </Row>
      </Container>
    </section>
  );
}

export default Conclusion;
